import { SITENAMEALIAS } from "./init";

/**
 * Applies a given URL as the site's favicon to all relevant icon tags.
 * @param {string} href 
 */
function applyFavicon(href) {
  if (!href) return;

  // 1. Update all standard icon tags
  const selectors = [
    "link[rel='icon']",
    "link[rel='shortcut icon']",
    "link[rel='apple-touch-icon']",
    "link[rel='apple-touch-icon-precomposed']",
  ];

  let found = false;
  selectors.forEach((selector) => {
    const links = document.querySelectorAll(selector);
    links.forEach((link) => {
      link.href = href;
      found = true;
    });
  });

  // 2. Fallback: if no rel="icon" tag was found/updated, create a new one
  if (!found) {
    const link = document.createElement("link");
    link.rel = "icon";
    link.href = href;
    document.head.appendChild(link);
  }
}

/**
 * Updates the favicon to match the exchange logo.
 * If a logoUrl is provided, it uses that and syncs it to localStorage.
 * Otherwise, it falls back to the logo stored in localStorage.
 * 
 * @param {string} [logoUrl] - Optional URL of the exchange logo.
 */
export function updateFavicon(logoUrl) {
  if (logoUrl) {
    localStorage.setItem(SITENAMEALIAS + "_exchangeLogo", logoUrl);
    // Notify other components in the same tab
    window.dispatchEvent(
      new CustomEvent("EXCHANGE_LOGO_UPDATED", { detail: logoUrl })
    );
  }
  
  const logo = logoUrl || localStorage.getItem(SITENAMEALIAS + "_exchangeLogo");
  if (logo) {
    applyFavicon(logo);
  }
}

/**
 * Helper to set both exchange logo in storage and update favicon.
 * Maintained for backward compatibility or explicit calls.
 */
export function setExchangeLogoAndFavicon(logoUrl) {
  updateFavicon(logoUrl);
}

